import type { UserResponse } from './types';
import {
  tenantHasWhatsAppModule,
  tenantHasWhatsAppProvider,
  type TenantFeature,
  type WhatsAppProvider,
} from '@workspace/types';

export function getEffectiveModuleFeatures(user: UserResponse | null | undefined): string[] {
  if (!user) {
    return [];
  }
  return user.features ?? user.tenantFeatures ?? [];
}

export function hasModuleFeature(
  user: UserResponse | null | undefined,
  feature: string,
): boolean {
  if (user?.role === 'SUPERADMIN') {
    return true;
  }
  return getEffectiveModuleFeatures(user).includes(feature);
}

export function hasWhatsAppModuleAccess(user: UserResponse | null | undefined): boolean {
  if (user?.role === 'SUPERADMIN') {
    return true;
  }
  return tenantHasWhatsAppModule(getEffectiveModuleFeatures(user) as TenantFeature[]);
}

export function hasWhatsAppProviderAccess(
  user: UserResponse | null | undefined,
  provider: WhatsAppProvider,
): boolean {
  if (user?.role === 'SUPERADMIN') {
    return true;
  }
  return tenantHasWhatsAppProvider(getEffectiveModuleFeatures(user) as TenantFeature[], provider);
}
